export const IS_MAINLINE = import.meta.env.TM_CHANNEL === 'mainline';
export const MAINLINE_API = '/api/mainline';
export function mainlineMarket(search:string):'us'|'cn'{return new URLSearchParams(search).get('market')==='cn'?'cn':'us';}
export function classicPath(path:string):string {
 return path==='/classic'?'/':path.startsWith('/classic/')?path.slice('/classic'.length):path;
}
export function classicHref(path:string):string {
 const suffix=classicPath(path);
 return `/classic${suffix.startsWith('/')?suffix:'/'+suffix}`;
}
/** Both markets live on the main site. No parameter always means US. */
export function marketSwitchHref(market:'us'|'cn',_path='/today'):string {
 return `/?market=${market}`;
}
